var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleRear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 247,
    viewBox: "0 0 232 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.314 2.60568C187.201 2.80639 193.017 8.49319 193.998 13.5778C202.197 40.473 212.079 97.6086 212.079 124.303V186.724C212.079 193.08 211.658 202.781 210.467 209.07C209.486 214.757 207.664 217.834 197.783 217.834L34.4278 217.901C24.4064 217.901 22.7246 214.757 21.6734 209.07C20.482 202.781 20.1317 193.147 20.1317 186.791L20.0615 124.37C20.0615 97.6086 30.2931 40.473 37.7916 13.6448C38.7727 8.56009 44.5892 2.8733 50.4759 2.67259C74.8634 1.86974 91.6825 1 116.07 1C140.388 1 156.856 1.73594 181.314 2.60568Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8643 11.1706C71.1495 9.02856 93.5046 8.82775 115.86 8.89469C138.285 8.96162 160.781 9.56406 183.206 11.4383",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.457 10.9019L53.6995 2.20442",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.702 11.3033L177.46 2.20442",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.624 31.3074H189.163",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7266 31.3074H43.4675",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.61 20.67H186.009",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0391 20.67H46.3407",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.643 181.706H212.079",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.298 73.4571L202.408 73.9923C203.319 73.9923 203.389 74.929 203.389 75.4642L203.319 81.0172C203.319 82.0877 202.478 82.4891 202.338 82.4891L193.438 82.8905",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.298 74.9941L188.393 75.3286C187.902 75.3286 187.832 75.9976 187.832 76.2652V80.0118C187.832 80.6809 188.253 80.9485 188.393 80.9485L193.929 81.2161",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.292 168.258L204.931 168.794C205.632 168.794 205.772 169.797 205.772 170.265L205.702 176.153C205.702 177.09 205.001 177.625 204.861 177.625L196.802 177.826",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.801 170.065L191.125 170.399C190.564 170.399 190.494 171.069 190.494 171.336V175.551C190.494 176.22 191.055 176.488 191.125 176.488L197.082 176.822",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.012 168.058C197.082 154.543 197.152 143.036 196.872 129.455C202.759 130.391 210.607 141.163 210.607 145.712V164.111C210.607 166.318 210.187 168.125 206.193 168.125H197.012V168.058Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4279 217.766C24.5468 217.766 22.7246 214.689 21.7435 209.002C20.5522 202.713 20.1318 193.012 20.1318 186.656V178.36H35.1989L36.3902 197.026C89.5103 197.026 142.7 197.026 195.82 197.026L197.082 178.36H212.149V186.656C212.149 193.012 211.728 202.713 210.537 209.002C209.556 214.689 207.734 217.766 197.853 217.766C143.261 217.766 88.8795 217.766 34.4279 217.766Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.009 117.88C211.939 113.866 211.729 109.718 211.448 105.436L215.653 105.369L215.513 93.1258C215.513 91.1856 217.965 88.7771 220.068 88.7771H226.445C228.548 88.7771 231 90.7842 231 93.1258L230.93 112.795C230.93 115.137 228.688 117.01 226.375 117.144L212.009 117.88Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.037 127.381C140.037 127.314 140.037 127.314 139.967 127.247C139.686 125.44 138.215 124.437 135.832 124.102C133.449 123.835 133.239 123.835 131.066 124.102C128.964 124.37 127.563 125.574 127.002 127.247C127.563 125.641 128.964 124.37 131.066 124.102C133.239 123.835 133.519 123.835 135.832 124.102C138.215 124.437 139.686 125.44 139.967 127.247C140.037 127.314 140.037 127.314 140.037 127.381Z",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.002 131.261C127.352 132.867 128.894 134.74 131.066 135.008C133.309 135.276 133.589 135.276 135.832 135.008C138.144 134.74 139.826 133.469 139.967 131.864C140.037 131.596 140.037 131.395 140.037 131.195C139.967 131.395 139.967 131.596 139.967 131.864C139.826 133.469 138.144 134.673 135.832 135.008C133.589 135.276 133.309 135.276 131.066 135.008C128.894 134.74 127.352 132.867 127.002 131.261Z",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.25 131.261C125.32 131.194 125.32 130.993 125.32 130.926V127.715C125.32 127.581 125.25 127.447 125.25 127.38H142.7C143.541 127.38 144.171 127.982 144.171 128.852V129.789C144.171 130.592 143.541 131.261 142.7 131.261H125.25Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.34 126.779H118.874C118.313 126.779 117.893 127.18 117.893 127.715V130.927C117.893 131.462 118.313 131.863 118.874 131.863H124.34C124.9 131.863 125.321 131.462 125.321 130.927V127.715C125.321 127.18 124.9 126.779 124.34 126.779Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.606 127.983C120.835 127.983 120.204 128.585 120.204 129.388C120.204 130.125 120.835 130.727 121.606 130.727C122.447 130.727 123.077 130.125 123.077 129.388C123.077 128.585 122.377 127.983 121.606 127.983Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 109.718H180.543C184.327 109.718 188.321 106.506 188.041 102.559L184.887 57.1984C184.607 53.2511 181.524 50.0397 177.389 50.0397H130.436C123.568 50.0397 122.938 50.4412 122.938 57.1984V102.559C122.938 106.239 126.582 109.718 130.436 109.718H132.118",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.304 106.842H177.46C182.506 106.842 185.379 104.768 184.958 99.6832L181.805 60.0763C181.384 54.2557 180.543 52.9177 174.306 52.9177H133.45C125.181 52.9177 125.952 53.5867 125.952 60.0763V99.6832C125.952 103.63 128.755 106.842 133.45 106.842H135.132",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4567 164.445H101.073C102.264 164.445 103.245 165.515 103.245 166.519V173.343C103.245 174.346 102.124 175.417 101.073 175.417H51.4567C50.4055 175.417 49.2842 174.48 49.2842 173.343V166.519C49.2842 165.314 50.2654 164.445 51.4567 164.445Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.012 167.924V180.636",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.028 205.59C210.818 206.862 210.678 207.999 210.397 209.136C209.416 214.823 207.594 217.901 197.713 217.901H185.939V243.525C185.939 244.93 187.131 246 188.532 246H208.365C209.836 246 210.958 244.863 210.958 243.525V205.59H211.028Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M116.07 32.8459V196.291",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M182.855 11.6374C187.06 21.8736 190.844 37.5959 191.545 44.1525C194.418 70.3117 197.082 124.236 197.082 131.261",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0746 11.1693C47.1825 16.0532 41.2958 39.2018 40.525 46.5612C37.7218 72.9881 35.1289 124.437 35.1289 131.261",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127.773 158.625H187.34C188.672 158.625 189.653 157.689 189.653 156.418V152.337C189.653 151.065 188.462 150.129 187.34 150.129H124.409C123.218 150.129 122.097 151.266 122.097 152.337V156.418C122.097 157.421 123.078 158.625 124.409 158.625H126.301",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M193.438 201.778H185.029C184.678 201.778 184.188 202.246 184.188 202.581L183.697 205.926C183.697 206.26 184.048 206.729 184.538 206.729H192.948C193.438 206.729 193.789 206.394 193.789 205.926L194.279 202.581C194.349 202.112 193.859 201.778 193.438 201.778Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M195.82 196.022L194.629 217.833",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.07 9.02863V196.291",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.366 158.625H44.799C43.4675 158.625 42.4863 157.689 42.4863 156.418V152.337C42.4863 151.065 43.6777 150.129 44.799 150.129H107.73C108.922 150.129 110.043 151.266 110.043 152.337V156.418C110.043 157.421 109.062 158.625 107.73 158.625H105.838",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 154.343V173.879C110.043 178.629 105.629 179.833 100.653 179.833H51.8077C46.8321 179.833 42.417 178.896 42.417 173.879V154.343",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2001 158.759H110.043L107.941 160.565V173.076C107.941 176.823 106.399 178.227 102.475 178.227H49.9856C46.0611 178.227 44.5194 177.558 44.5194 173.076V160.565L42.417 158.759H48.9344",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5195 160.765H108.152",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8933 159.361H58.8154V160.365H65.8933V159.361Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7849 159.361H86.707V160.365H93.7849V159.361Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.075 146.583H113.757C114.177 146.583 114.388 146.851 114.388 147.185V152.805C114.388 153.207 114.107 153.407 113.757 153.407H112.075C111.655 153.407 111.444 153.14 111.444 152.805V147.185C111.374 146.784 111.655 146.583 112.075 146.583Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.173 146.583H119.854C120.275 146.583 120.485 146.851 120.485 147.185V152.805C120.485 153.207 120.205 153.407 119.854 153.407H118.173C117.752 153.407 117.542 153.14 117.542 152.805V147.185C117.542 146.784 117.752 146.583 118.173 146.583Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M100.723 152.603H50.5459V156.751H100.723V152.603Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M166.947 152.603H186.639L183.976 156.751H164.284L166.947 152.603Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.152 143.773C197.152 146.047 197.222 148.255 197.152 150.396H210.678V145.646C210.678 145.044 210.608 144.509 210.397 143.773H197.152Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M197.152 150.396C197.152 153.273 197.152 156.15 197.152 159.093H210.608V150.396H197.152Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M211.238 197.094H186.71",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4278 181.706H20.0615",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.773 73.4571L29.6627 73.9923C28.7517 73.9923 28.6816 74.929 28.6816 75.4642L28.7516 81.0172C28.7516 82.0877 29.5927 82.4891 29.7328 82.4891L38.6329 82.8905",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7732 74.9941L43.6788 75.3286C44.1693 75.3286 44.2394 75.9976 44.2394 76.2652V80.0118C44.2394 80.6809 43.8189 80.9485 43.6788 80.9485L38.1426 81.2161",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7785 168.258L27.1399 168.794C26.4391 168.794 26.2988 169.797 26.2988 170.265L26.369 176.153C26.369 177.09 27.0697 177.625 27.2099 177.625L35.269 177.826",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2685 170.065L40.945 170.399C41.5057 170.399 41.5757 171.069 41.5757 171.336V175.551C41.5757 176.22 41.0151 176.488 40.945 176.488L34.9883 176.822",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34.989 168.058C34.919 154.543 34.8488 143.036 35.1292 129.455C29.2425 130.391 21.3936 141.163 21.3936 145.712V164.111C21.3936 166.318 21.8141 168.125 25.8086 168.125H34.989V168.058Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9914 117.88C20.0615 113.866 20.2717 109.718 20.552 105.436L16.3473 105.369L16.4874 93.1258C16.4874 91.1856 14.0346 88.7771 11.9323 88.7771H5.55515C3.45277 88.7771 1 90.7842 1 93.1258L1.06998 112.795C1.06998 115.137 3.31251 117.01 5.62513 117.144L19.9914 117.88Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.71 109.718H51.4577C47.6734 109.718 43.6789 106.506 43.9593 102.559L47.1128 57.1984C47.3931 53.2511 50.4766 50.0397 54.6113 50.0397H101.564C108.432 50.0397 109.063 50.4412 109.063 57.1984V102.559C109.063 106.239 105.419 109.718 101.564 109.718H99.8824",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6964 106.842H54.541C49.4952 106.842 46.622 104.768 47.0425 99.6832L50.1961 60.0763C50.6165 54.2557 51.4575 52.9177 57.6945 52.9177H98.5508C106.82 52.9177 106.049 53.5867 106.049 60.0763V99.6832C106.049 103.63 103.246 106.842 98.5508 106.842H96.8689",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9883 167.924V180.636",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9727 205.59C21.1829 206.862 21.323 207.999 21.6033 209.136C22.5844 214.823 24.4065 217.901 34.2877 217.901H46.0611V243.525C46.0611 244.93 44.8696 246 43.468 246H23.6357C22.164 246 21.0426 244.863 21.0426 243.525V205.59H20.9727Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5627 201.778H46.9722C47.3226 201.778 47.8133 202.246 47.8133 202.581L48.3038 205.926C48.3038 206.26 47.9535 206.729 47.4629 206.729H39.0534C38.5629 206.729 38.2123 206.394 38.2123 205.926L37.7218 202.581C37.6517 202.112 38.2123 201.778 38.5627 201.778Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 196.022L37.4413 217.833",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9189 143.773C34.9189 146.047 34.8488 148.255 34.9189 150.396H21.3936V145.646C21.3936 145.044 21.4637 144.509 21.674 143.773H34.9189Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9181 150.396C34.9181 153.273 34.9181 156.15 34.9181 159.093H21.4629V150.396H34.9181Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7627 197.027H45.2904",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4482 217.768C109.553 217.768 122.658 217.768 135.763 217.768C135.132 222.25 126.512 225.796 116.141 225.796C105.629 225.796 97.079 222.25 96.4482 217.768Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRear);
export default __webpack_public_path__ + "static/media/vehicle-rear.8e78d5646b25a23d093940051cac6e8c.svg";
export { ForwardRef as ReactComponent };